module.exports = __webpack_public_path__ + "static/media/starviosLogoSquare.c37079b9.png";